export default "__VITE_ASSET__C37t9XMW__"